const BEFORE_EVENT = 'before-event';
const AFTER_EVENT = 'after-event';
export  {BEFORE_EVENT, AFTER_EVENT}